export enum ProposalExportType {
    PDF = 'pdf', XLSX = 'xlsx', XLSX_CUSTOMER = 'xlsx_customer'
}